import { formatDateAndTime } from "./formatDateAndTime";

export const printSlip = (data) => {

    const concernText = data.concern || "";

    const isLongConcern = concernText.length > 35;

    const concernHTML = isLongConcern
    ? `
        <div class="concern-block">
        <div class="concern-label">Concern</div>
        <div class="concern-text">
            ${concernText.replace(/\n/g, "<br>")}
        </div>
        </div>
    `
    : `
        <div class="row">
        <span>Concern</span>
        <span>${concernText}</span>
        </div>
    `;
  const content = `
      <div class="slip">
  
        <!-- HEADER -->
        <div class="center bold">BINNY'S</div>
  
        <div class="divider"></div>

        <div class="row">
          <span>SR No.</span>
          <span>${data.srNo}</span>
        </div>

        <div class="divider"></div>
  
        <!-- CLIENT (NO LABEL) -->
        <div class="center bold">${data.clientName || ""}</div>
        <div class="center">(${data.clientCode || ""})</div>
  
        <div class="divider"></div>
  
        <!-- DESIGN -->
        <div class="row">
          <span>Design No.</span>
          <span>${data.designNo || ""}</span>
        </div>
  
        <div class="divider"></div>
  
        <!-- DETAILS -->
        <div class="row">
          <span>SR Date</span>
          <span>${data.dueDate || ""}</span>
        </div>

        <div class="row">
          <span>Gold WT</span>
          <span>${data.grossWt || ""}</span>
        </div>

        <div class="row">
          <span>Diamond WT</span>
          <span>${data.diamondWt || ""}</span>
        </div>

        <div class="divider"></div>
  
        ${concernHTML}
  
        <div class="divider"></div>
  
        <!-- FOOTER -->
        <div class="row">
          <span>Print By</span>
          <span>${data.username || ""}</span>
        </div>
  
        <div class="center date">${formatDateAndTime(new Date())}</div>
  
        <div class="divider"></div>
  
        <div class="center">*** Thank You ***</div>
  
      </div>
    `;

  const style = `
      <style>
        @page {
        size: 58mm auto;
        margin: 0 !important;
        }

        html, body {
        width: 58mm;
        margin: 0 !important;
        padding: 0 !important;
        font-family: monospace;
        }

        .slip {
        padding: 0 5mm 5mm 5mm;
        }
  
        .divider {
          border-top: 1px dashed #000;
          margin: 6px 0;
        }
  
        .row {
          display: flex;
          justify-content: space-between;
          padding: 2px 0;
          font-size: 12px;
        }
  
        .row span:first-child {
          font-weight: bold;
        }
  
        .center {
          text-align: center;
          font-size: 12px;
        }
  
        .bold {
          font-weight: bold;
          font-size: 14px;
        }
  
        .date {
          font-size: 10px;
          margin-top: 4px;
        }

        .concern-block {
        padding: 2px 0;
        font-size: 12px;
        }

        .concern-label {
        font-weight: bold;
        margin-bottom: 2px;
        }

        .concern-text {
        padding-left: 10px;
        word-break: break-word;
        white-space: normal;
        line-height: 1.4;
        }
      </style>
    `;

  const win = window.open("", "_blank", "width=400,height=600");

  win.document.write(`
      <html>
        <head>
          <title>Print Slip</title>
          ${style}
        </head>
        <body>
          ${content}
        </body>
      </html>
    `);

  win.document.close();

  win.onload = function () {
    win.document.body.style.margin = "0";
    win.document.body.style.padding = "0";
  
    win.focus();
  
    setTimeout(() => {
      win.print();
      win.close();
    }, 200);
  };
};
